var render = function render(){var _vm=this,_c=_vm._self._c;return _c('font-awesome-icon',{staticClass:"icon ml-2 text-success",attrs:{"icon":['fas', 'check']}})
}
var staticRenderFns = []

export { render, staticRenderFns }